"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("@nicbase/hooks");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AssetGroupFilter = function AssetGroupFilter(props) {
  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _usePortalAssetGroups = (0, _hooks.usePortalAssetGroups)(portalId, {
    enabled: Boolean(portalId),
    select: function select(groups) {
      return groups.reduce(function (result, next) {
        var nextResult = result;
        nextResult[next.id] = next.name;
        return nextResult;
      }, {});
    }
  }),
      assetGroups = _usePortalAssetGroups.data;

  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, _extends({}, props, {
    source: assetGroups,
    debounceTime: 400,
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.AssetGroup, null),
    valueType: "Integer"
  }));
};

AssetGroupFilter.propTypes = _nicbaseForms.Autocomplete.propTypes;
AssetGroupFilter.defaultProps = _nicbaseForms.Autocomplete.defaultProps;
var _default = AssetGroupFilter;
exports["default"] = _default;